export default __webpack_public_path__ + "static/media/bag.1f47af24.svg";